import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map, finalize } from 'rxjs';
import { ConfigService } from './config.service';
import { SpinnerService } from './SpinnerService';

@Injectable()
export class TabellaService {
	constructor(private http: HttpClient, private configService: ConfigService, private spinnerService: SpinnerService) {}

	getView(urlservizi: string, listname: string, cerca: string, cercaOption: string, orderby: string, limitda: number, limitper: number): Observable<any> {
		this.spinnerService.show();
		return this.http.get(`${urlservizi}${listname}?${cercaOption}=${cerca}&orderby=${orderby}&limitda=${limitda}&limitper=${limitper}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	postView(urlservizi: string, username: string, pt_id: number, listname: string, orderby: string, limitda: number, limitper: number, params: any): Observable<any> {
		this.spinnerService.show();
		return this.http.post(`${urlservizi}${listname}/${username}/${pt_id}?orderby=${orderby}&limitda=${limitda}&limitper=${limitper}`, params, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	delete(urlservizi: string, id: number): Observable<any> {
		this.spinnerService.show();
		return this.http.delete(`${urlservizi}del/${id}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	eliminaFile(username: string, doc_tablename: string, doc_idkey: number, tipo: number): Observable<any> {
		this.spinnerService.show();
		return this.http.delete(`${this.configService.portalUrl}del/file/${username}/${doc_tablename}/${doc_idkey}/${tipo}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}

	recuperaFile(username: string, doc_tablename: string, doc_idkey: number, tipo: number): Observable<any> {
		this.spinnerService.show();
		const host = window.location.hostname;
		return this.http.get(`${this.configService.portalUrl}getdoc/${username}/${doc_tablename}/${doc_idkey}?tipo=${tipo}&host=${host}`, { observe: 'response' }).pipe(
			map((response) => response.body),
			finalize(() => this.spinnerService.hide()),
		);
	}
}
